import "../css/index.scss";
import $ from "jquery/dist/jquery";
// "bootstrap5" (ne "bootstrap") schválně — nxcms-js přes tenhle alias inicializuje
// Modal/Collapse. Import z holého "bootstrap" natáhne DRUHOU, nezávislou kopii
// modulu (jiný soubor v node_modules, i když je obsahem identický) — Bootstrap si
// při importu jako vedlejší efekt registruje globální click-listenery pro všechny
// komponenty včetně Dropdownu, takže by pak existovaly dvě sady, co si klik
// přebírají — dropdown/kolaps se otevře a hned zase sám zavře.
import { Tooltip } from "bootstrap5";

//import "bootstrap/dist/js/bootstrap.bundle";

import "@nxcms/nxcms-js/src/js/sentry";

import "@nxcms/nxcms-js/src/js/static/bootstrap_5";
import "@nxcms/nxcms-js/src/js/static";
import "@nxcms/nxcms-js/src/js/blog";

import "@nxcms/nxcms-js/src/js/eshop-watchdog";
import "@nxcms/nxcms-js/src/js/eshop-rate";

// Vue košík si výhradně pro sebe táhne vee-validate, yup a tanstack query
// (~300 KiB zdrojů) a element <eshop-cart> je jen na stránce košíku — v navbaru
// je košík vykreslený serverem. Custom element se upgraduje i zpětně, takže
// stačí modul dotáhnout tam, kde ten element opravdu je.
if (document.querySelector("eshop-cart")) {
  import("@nxcms/nxcms-js/src/vue-component/eshop-cart");
}
// Vyhledávání je v navbaru na každé stránce, to zůstává staticky.
import "@nxcms/nxcms-js/src/vue-component/search2";

import "@nxcms/nxcms-js/src/js/eshop";

import "@nxcms/nxcms-js/src/js/ga4-eec";
import "@nxcms/nxcms-js/src/js/gallery";

import "@nxcms/nxcms-js/src/js/delivery-zasilkovna";
import "@nxcms/nxcms-js/src/js/delivery-balikobot-pickup";

import "@nxcms/nxcms-js/src/js/eshop-watchdog";
import "@nxcms/nxcms-js/src/js/gdpr";

import "./10_akce_strip";

window.jQuery = window.$ = $;

// ── Výdejní místa Balíkobotu ────────────────────────────────────────────────
// vue-component/balikobot-pickup s sebou táhne OpenLayers (ol, vue3-openlayers,
// ol-ext, geotiff) — 4,8 MB zdrojů, tedy víc než polovinu celého bundlu. Mapa se
// přitom otevře jedině v košíku při volbě výdejního místa, takže nemá smysl
// posílat ji na každou stránku. Custom element se upgraduje i zpětně, takže
// stačí modul dotáhnout ve chvíli, kdy se <bb-pickup-point-selector> objeví
// v DOM — jen musíme počkat na dokončení importu, než na něj sáhneme.
let pickupSelectorModule = null;
function loadPickupSelector() {
  pickupSelectorModule ??= import("@nxcms/nxcms-js/src/vue-component/balikobot-pickup");
  return pickupSelectorModule;
}

function stylePickupSelector(el) {
  el.markerFillColor = "#13b6ff";
  el.markerSelectedStrokeColor = "#ffd500";
}

// V košíku modul předtáhneme na pozadí, aby na něj zákazník po volbě dopravy
// nečekal. Na ostatních stránkách se nestáhne vůbec.
if (document.querySelector("eshop-cart")) {
  loadPickupSelector();
}

(function () {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        const el = node.tagName === "BB-PICKUP-POINT-SELECTOR"
          ? node
          : node.querySelector && node.querySelector("bb-pickup-point-selector");
        if (el) {
          loadPickupSelector().then(function () {
            stylePickupSelector(el);
          });
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// Neaktivní slidy karuselu drží mimo tab order i mimo strom přístupnosti —
// leží pod aktivním, jsou jen průhledné, ale klávesnicí se do jejich odkazů
// dalo vstoupit. Výchozí stav nastavuje šablona (inert na všech kromě prvního),
// tady ho jen přehazujeme podle toho, co Bootstrap zrovna aktivoval.
(function () {
  const carousel = document.getElementById("carouselPZAutoplaying");
  if (!carousel) return;

  // Obrázky slidů 2–7 mají adresy jen v data-* (viz hpcarousel_slide.html),
  // aby se všech sedm nestahovalo hned při načtení stránky. Doplníme je ve chvíli,
  // kdy se na ten slide přepíná — tedy dřív, než ho je vidět.
  function hydrateSlideImage(slide) {
    if (!slide) return;
    var img = slide.querySelector("img.carousel-background[data-src]");
    if (!img) return;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    delete img.dataset.src;
    delete img.dataset.srcset;
  }

  // Následující slide předtáhneme, jakmile je stránka hotová — karusel se sám
  // přepne po devíti sekundách, takže do té doby musí být obrázek připravený.
  // Ne dřív než v idle: o šířku pásma s LCP prvkem se nedělíme. Slide dozadu
  // (tlačítko "předchozí") se dotáhne teprve při kliknutí; ušetří to 70 KiB
  // za interakci, kterou většina lidí neudělá.
  if ("requestIdleCallback" in window) {
    requestIdleCallback(function () {
      var active = carousel.querySelector(".carousel-item.active");
      if (active) hydrateSlideImage(active.nextElementSibling);
    }, { timeout: 4000 });
  }

  // Přicházející slide odinertujeme ještě před přechodem, aby fade a případný
  // fokus fungovaly celou dobu animace.
  carousel.addEventListener("slide.bs.carousel", function (e) {
    if (e.relatedTarget) {
      e.relatedTarget.removeAttribute("inert");
      hydrateSlideImage(e.relatedTarget);
      hydrateSlideImage(e.relatedTarget.nextElementSibling);
    }
  });

  carousel.addEventListener("slid.bs.carousel", function () {
    carousel.querySelectorAll(".carousel-item").forEach(function (item) {
      if (item.classList.contains("active")) item.removeAttribute("inert");
      else item.setAttribute("inert", "");
    });
  });
})();

// ── Responsive variant display ───────────────────────────────────────────────
(function () {
  function getVariantLimit() {
    const w = window.innerWidth;
    if (w >= 1370) return 5;
    if (w >= 768) return 4;
    return 3;
  }

  function updateVariants() {
    document.querySelectorAll(".variantsc.base").forEach(function (grid) {
      const total = parseInt(grid.dataset.variantTotal, 10);
      const limit = getVariantLimit();
      const items = grid.querySelectorAll(".variant-selector");
      const btn = grid.querySelector(".variant-count-indicator");

      if (!btn) return;

      if (total > limit) {
        items.forEach(function (item, i) {
          item.classList.toggle("d-none", i >= limit - 1);
        });
        const remaining = total - (limit - 1);
        const label = remaining >= 5 ? "dalších" : "další";
        btn.querySelector(".variant-count-text").textContent =
          "+" + remaining + " " + label;
        btn.classList.remove("d-none");
      } else {
        items.forEach(function (item) {
          item.classList.remove("d-none");
        });
        btn.classList.add("d-none");
      }
    });
  }

  document.addEventListener("DOMContentLoaded", updateVariants);
  window.addEventListener("resize", updateVariants);
})();

// ── Mobile facet modal teleport ───────────────────────────────────────────────
// .comp__sidemenu is display:none on mobile — modal inside it would be hidden.
// Moving #staticBackdrop to <body> ensures it is always visible when triggered.
(function () {
    function teleportFacetModal() {
        var existing = document.getElementById('staticBackdrop');
        if (existing && existing.parentElement === document.body) {
            existing.remove();
        }
        var modal = document.getElementById('staticBackdrop');
        if (modal) {
            document.body.appendChild(modal);
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        teleportFacetModal();

        var target = document.getElementById('itemListContentLeft');
        if (!target) return;
        new MutationObserver(function () {
            teleportFacetModal();
        }).observe(target, { childList: true });
    });

    // Initialize price sliders inside modal only when it's fully visible
    document.addEventListener('shown.bs.modal', function (e) {
        if (e.target && e.target.id === 'staticBackdrop') {
            $(e.target).find('.facet-slider:not(.noUi-target)').facetSlider();
        }
    });
})();

// ── Facet option truncation ───────────────────────────────────────────────────
(function () {
    const LIMIT = 5;

    function initFacetTruncation(root) {
        (root || document).querySelectorAll('.facetSectionBody').forEach(function (section) {
            var existing = section.querySelector('.facet-show-more');
            if (existing) existing.remove();

            var options = section.querySelectorAll('.form-check');
            if (options.length <= LIMIT) {
                options.forEach(function (opt) { opt.classList.remove('facet-option--hidden'); });
                return;
            }

            options.forEach(function (opt, i) {
                opt.classList.toggle('facet-option--hidden', i >= LIMIT);
            });

            var toggle = document.createElement('a');
            toggle.href = '#';
            toggle.className = 'facet-show-more';
            toggle.dataset.expanded = 'false';
            toggle.textContent = 'Zobrazit všechny (' + options.length + ')';

            toggle.addEventListener('click', function (e) {
                e.preventDefault();
                var expanded = toggle.dataset.expanded === 'true';
                options.forEach(function (opt, i) {
                    if (i >= LIMIT) opt.classList.toggle('facet-option--hidden', expanded);
                });
                toggle.dataset.expanded = String(!expanded);
                toggle.textContent = expanded
                    ? 'Zobrazit všechny (' + options.length + ')'
                    : 'Zobrazit méně';
            });

            section.appendChild(toggle);
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        initFacetTruncation();

        var target = document.getElementById('itemListContentLeft');
        if (!target) return;

        new MutationObserver(function () {
            initFacetTruncation(target);
        }).observe(target, { childList: true });
    });
})();

// ── AJAX clear-all facets (facet-clear / btn-filtry-clear / mobile-facet-clear)
(function () {
    $(document).on('click', '.facet-clear, .btn-filtry-clear, .mobile-facet-clear', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var resultTarget = $('#itemListContent');
        var menuTarget = $('#itemListContentLeft');

        if (!resultTarget.length) {
            window.location = href;
            return;
        }

        $.ajax({ method: 'get', url: href, data: { contentOnly: '1' } })
            .done(function (d) {
                if (window.NXCMS) window.NXCMS.closeAllModals();
                resultTarget.html(d.item_content);
                menuTarget.html(d.menu_addon);
                resultTarget.find('.facetfilter .facet-slider').facetSlider();
                menuTarget.find('.facetfilter .facet-slider').facetSlider();
            })
            .fail(function () {
                window.location = href;
            });
    });
})();

// ── Search modal — mobile filter collapse ─────────────────────────────────────
(function () {
    document.addEventListener('click', function (e) {
        if (window.innerWidth > 767) return;
        var head = e.target.closest('.nxcms-search .ns-filters-head');
        if (!head) return;
        var filters = head.closest('.ns-filters');
        if (filters) filters.classList.toggle('is-open');
    });
})();

// ── Cenový tooltip (nejnižší cena za 30 dní) ──────────────────────────────────
// Bootstrap tooltips se na rozdíl od modalů neaktivují samy přes data-bs-toggle,
// je potřeba je ručně inicializovat.
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (el) {
      // "click" navíc kvůli mobilu — samotné hover/focus na dotek nespolehlivě
      // spouští, takže bez něj by se tooltip na mobilu prakticky nedal otevřít.
      new Tooltip(el, { trigger: "hover focus click" });
    });
  });
})();

// ── Global messages auto-close ────────────────────────────────────────────────
(function () {
  const AUTO_CLOSE_MS = 6000;

  function dismissMessage(li) {
    li.classList.add("is-hiding");
    li.addEventListener("transitionend", () => li.remove(), { once: true });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll("#global-messages .message")
      .forEach(function (li) {
        setTimeout(() => dismissMessage(li), AUTO_CLOSE_MS);
      });
  });
})();
